
<fieldset class="btn-group btn-group-toggle switch-view d-inline-block">
  <legend class="sr-only">Switch between List View and Card View</legend>
  <button id="btnListView" class="btn btn-common btn-sm tooltip top position-relative" [attr.aria-label]="'List view'" data-tooltip="List view" (click)="changeView('listview')"
    [ngClass]="{'active':viewType === 'listview'}" [attr.aria-pressed]="viewType === 'listview' ? true : false">
    <em class="material-icons-outlined button-icon font-4x" aria-hidden="true">list_alt</em>
  </button>
  <button id="btnCardView" class="btn btn-common btn-sm tooltip top top-right position-relative" [attr.aria-label]="'Card view'" data-tooltip="Card view" (click)="changeView('cardview')"
    [ngClass]="{'active':viewType === 'cardview'}" [attr.aria-pressed]="viewType === 'cardview' ? true : false">
    <em class="material-icons-outlined button-icon font-4x" aria-hidden="true">grid_view</em>
  </button>
</fieldset>